export default {
    manage_importCustomers_comma: "Comma",
    manage_importCustomers_semicomma: "SemiColon",
    manage_importCustomers_isRequired: "is required",
    manage_importCustomers_latitudeAndLogitudeRequired: "Latitude and Longitude are required",
    manage_importCustomers_latitudeIsInvalid: "Latitude is invalid",
    manage_importCustomers_longitudeIsInvalid: "Longitude is invalid",
    manage_importCustomers_tag: "Tag",
    manage_importCustomers_doesNotExist: "does not exist",
    manage_importCustomers_nameIsInvalid: "Name is invalid, please remove special characters",
    manage_importCustomers_pleaseFixErrorsBeforeContinuing: "Please fix errors before continuing",
    manage_importCustomers_successMessages: "The import has been started, you will be notified when completed",
    manage_importCustomers_requiredFileCSV: "Required File CSV",
    manage_importCustomers_title: "Import Customers",
    manage_importCustomers_upload: "Upload",
    manage_importCustomers_downloadTemplate: "Download Template",
    manage_importCustomers_delimiter: "Delimiter",
    manage_importCustomers_fileCSV: "File (CSV)",
    manage_importCustomers_fileHelpText: "Supported CSV formats: comma, semicolon, tab.",
    manage_importCustomers_chooseFile: "Choose File",
    manage_importCustomers_name: "Name",
    manage_importCustomers_ein: "EIN",
    manage_importCustomers_locationName: "Location Name",
    manage_importCustomers_city: "City",
    manage_importCustomers_state: "State",
    manage_importCustomers_zip: "Zip",
    manage_importCustomers_latitude: "Latitude",
    manage_importCustomers_longitude: "Longitude",
    manage_importCustomers_description: "Description",
    manage_importCustomers_contactName: "Contact Name",
    manage_importCustomers_email: "Email",
    manage_importCustomers_phone: "Phone",
    manage_importCustomers_countryCode: "Country Code",
    manage_importCustomers_notifyByPhone: "Notify By Phone",
    manage_importCustomers_notifyByEmail: "Notify By Email",
    manage_importCustomers_tags: "Tags",
    manage_importCustomers_error: "Error",
    manage_importCustomers_errorFile: "Error in file, please review the delimiter",
    manage_importCustomers_maxSizeFile: "Max file size 5 mb"
}